import {Component, OnDestroy, OnInit} from '@angular/core';
import {RulesService} from '../rules.service';
import {RuleModel} from '../model/RuleModel';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {SpinnerService} from '../../core/spinner/spinner.service';
import {NotificationBarService} from '../../core/notify/notification.service';
import {NotificationType} from '../../core/notify';
import {ChannelService} from '../channel.service';

@Component({
  selector: 'app-rule-details',
  templateUrl: './rule-details.component.html',
  styleUrls: ['./rule-details.component.scss']
})
export class RuleDetailsComponent implements OnInit, OnDestroy {
  rule: RuleModel;
  sub;
  isLoading;
  constructor(private ruleService: RulesService,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private spinner: SpinnerService,
              private notification: NotificationBarService,
              private channelService: ChannelService) { }

  ngOnInit() {
    this.rule = this.ruleService.getRuleModel();
    this.subscribeRuleId();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
  get action() {
    return this.ruleService.getActionList()[0] ? this.ruleService.getActionList()[0] : {};
  }
  navigateToEditRule() {
    this.ruleService.navigateToEditRule(this.rule);
  }
  delete(rule) {
    this.spinner.show();
    this.ruleService.deleteRule(rule.id)
      .subscribe(res => {
      this.spinner.hide();
       this.goToRuleList();
      this.notification.create({message: 'Rule has been deleted successfully', type: NotificationType.Success});
    }, err => this.spinner.hide());
  }
  private subscribeRuleId() {
    this.sub = this.activatedRoute.params
      .subscribe((params: Params) => {
        let ruleId = params['id'];
        this.getRuleDetails(ruleId);
      });
  }
  private getRuleDetails(ruleId) {
    if (isNaN(ruleId)) {
      this.notification.create({message: 'Invalid rule id', type: NotificationType.Error});
      this.goToRuleList();
    }
    this.spinner.show();
    this.isLoading = true;
    this.channelService.getStatus(ruleId)
      .then(res => {
        this.spinner.hide();
        if (res) {
          this.rule = this.ruleService.getRuleModel();
          this.ruleService.setConditionRows(this.rule.predicate);
          this.ruleService.setActionList(this.rule.actions);
          this.isLoading = false;
        } else {
          this.goToRuleList();
        }
      }, err => this.goToRuleList());
  }

  private goToRuleList() {
    this.router.navigate([`/rules/list`]);
  }
}



// WEBPACK FOOTER //
// ./src/app/rules/rule-details/rule-details.component.ts